module.exports = __webpack_public_path__ + "static/img/cont53 (3).a3c2456.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont53 (3).jpg
// module id = 4Zhh
// module chunks = 0